import { render } from "./BatchStreamLogList.vue?vue&type=template&id=81daa19e&ts=true"
import script from "./BatchStreamLogList.vue?vue&type=script&lang=ts"
export * from "./BatchStreamLogList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__